import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaEnvelopeOpenText } from 'react-icons/fa';
import * as PATH from '../../../CentralisedLink';
import { verifyEmailChangeToken } from '../../../Redux/Dashboard/External/EmailMigration/EmailMigrationAction';

const safeDecodeURIComponent = (value) => {
  if (!value) {
    return value;
  }

  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
};

const sanitizeVerificationToken = (token) => {
  if (!token) {
    return '';
  }

  return safeDecodeURIComponent(token)
    .split('__;')[0]
    .split('__')[0]
    .trim();
};

const getTokenFromUrl = (urlValue) => {
  if (!urlValue) {
    return '';
  }

  const decodedUrl = safeDecodeURIComponent(urlValue);

  try {
    return new URL(decodedUrl).searchParams.get('token') || '';
  } catch (error) {
    const tokenMatch = decodedUrl.match(/[?&]token=([^&]+)/);
    return tokenMatch?.[1] || '';
  }
};

const getTokenFromUrlDefenseWrapper = (href) => {
  const wrapperMarker = '/v3/__';
  const wrapperStart = href.indexOf(wrapperMarker);

  if (wrapperStart === -1) {
    return '';
  }

  const originalUrlStart = wrapperStart + wrapperMarker.length;
  const suffixWithTracking = href.indexOf('__;', originalUrlStart);
  const suffixWithoutTracking = href.indexOf('__', originalUrlStart);
  const suffixCandidates = [suffixWithTracking, suffixWithoutTracking].filter((index) => index !== -1);
  const originalUrlEnd = suffixCandidates.length > 0
    ? Math.min(...suffixCandidates)
    : href.length;
  const originalUrl = href.slice(originalUrlStart, originalUrlEnd);

  return getTokenFromUrl(originalUrl);
};

export const getCleanVerificationToken = (locationLike = window.location) => {
  const search = locationLike?.search || '';
  const href = locationLike?.href || '';
  const directToken = new URLSearchParams(search).get('token');

  if (directToken) {
    return sanitizeVerificationToken(directToken);
  }

  return sanitizeVerificationToken(getTokenFromUrlDefenseWrapper(href));
};

const EmailChangeVerify = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = getCleanVerificationToken(window.location);

    console.log('[EmailVerify DEBUG] token found:', Boolean(token));
    console.log('[EmailVerify DEBUG] token length:', token?.length);

    if (!token) {
      navigate(PATH.EMAIL_VERIFICATION_INVALID_PATH, { replace: true });
      return;
    }

    let isMounted = true;

    const verifyToken = async () => {
      const result = await dispatch(verifyEmailChangeToken(token));

      if (!isMounted) {
        return;
      }

      if (result.success) {
        navigate(PATH.EMAIL_UPDATED_PATH, { replace: true });
        return;
      }

      navigate(PATH.EMAIL_VERIFICATION_INVALID_PATH, { replace: true });
    };

    verifyToken();

    return () => {
      isMounted = false;
    };
  }, [dispatch, navigate, location.pathname, location.search]);

  return (
    <main className="update-email-page email-change-verify-page">
      <section className="update-email-panel" aria-labelledby="email-change-verify-title">
        <div className="update-email-hero-icon" aria-hidden="true">
          <FaEnvelopeOpenText />
        </div>
        <h1 id="email-change-verify-title" className="update-email-title">
          Verifying Email
        </h1>
        <p className="update-email-subtitle">
          Please wait while we verify your email update link.
        </p>
      </section>
    </main>
  );
};

export default EmailChangeVerify;

